var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurityTaskHalo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    enableBackground: "new 0 0 42 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    transform: "translate(1591 787.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    fill: "#F9A134",
    d: "M-1555.8-766.1C-1555.8-766.1-1555.8-766.1-1555.8-766.1c0,0.1,0,0.2-0.1,0.4v0 c-0.2,1-0.5,2-1,2.9c0,0,0,0,0,0c-1.7,3.9-5.3,9.9-13.1,16.4c-7.9-6.5-11.5-12.5-13.1-16.4c0,0,0,0,0,0c-0.4-0.9-0.8-1.9-1-2.9v0 c-0.1-0.2-0.1-0.3-0.1-0.4c0,0,0,0,0-0.1c-0.2-0.9-0.3-1.8-0.3-2.8c0-8,6.5-14.5,14.5-14.5c8,0,14.5,6.5,14.5,14.5 C-1555.5-768-1555.6-767-1555.8-766.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityTaskHalo);
export default __webpack_public_path__ + "static/media/icon_security_task_halo.80af7d98ebfe5090981495013213058d.svg";
export { ForwardRef as ReactComponent };